import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { useMemo, useState, virtual } from 'haunted';
import { PrefAccent } from './sections/pref-accent.js';
import { PrefWidth } from './sections/pref-width.js';
import { PrefBasicSwitch, PrefBasicRadio } from './sections/pref-basic.js';
import { locale } from '@local/config';
import { getI18n } from './_i18n/i18n.js';

export const Customize = virtual(
  ({
    prefsBasic,
    prefsAccent,
    component,
    componentAccent,
    componentProps,
    unsafe = false
  }) => {
    const [viewportWidth, setViewportWidth] = useState('max-w-bk-6');
    const basics = {
      check: PrefBasicSwitch,
      radio: PrefBasicRadio
    };

    const currentLocale = locale();

    const literals = useMemo(
      () => getI18n(currentLocale) ?? getI18n('en'),
      [currentLocale]
    );

    return html`
      <div class="flex justify-center">
        <div class="w-full max-w-bk-6 flex flex-col items-center">
          <div class="flex flex-wrap justify-center">
            ${prefsBasic.map(item => {
              return html`
                <div class="mr-4 mb-6 flex items-center">
                  ${basics[item.type]({ ...item, literals })}
                </div>
              `;
            })}
          </div>
          <div class="mb-4 w-full">
            ${PrefAccent({ ...prefsAccent, literals })}
          </div>
          <div class="mb-2 w-full">
            ${PrefWidth({ viewportWidth, setViewportWidth, literals })}
          </div>
          <div
            class="w-full ${viewportWidth} flex justify-center pt-4 pb-4 accent-${componentAccent}"
          >
            ${
              unsafe
                ? unsafeHTML(component(componentProps))
                : component(componentProps)
            }
          </div>
        </div>
      </div>
    `;
  }
);
